import { ExtremwetterschutzSelbstbeteiligung } from '@ps20/bff-models';
import { IAppState } from '../../../store/appState';
import { ExtremeWetterschutzSelbstbeteiligungValues } from '../../../store/models/ExtremWetterschutzSelbstbeteiligungValues.model';
import { ZusatzoptionenNameVWGEnum } from '../../../store/models/zusatzoptionenVWG.model';
import { selectSelectedProduktlinie } from './produkt.selector';

export const selectElementarSelbstbehaltId = (state: IAppState): string =>
  state.elementarSelbstbehalt ? state.elementarSelbstbehalt.id : null;

export const selectElementarSelbstbehaltDescription = (state: IAppState): string =>
  state.elementarSelbstbehalt ? state.elementarSelbstbehalt.description : null;

export const selectExetremWetterschutzSelbstbeteiligungChosenValue = (
  state: IAppState,
): ExtremwetterschutzSelbstbeteiligung => state.extremeWetterschutzSelbstbeteiligung;

export const selectExtremeWetterschutzSelbstbeteiligungValuesList = (
  state: IAppState,
): ExtremeWetterschutzSelbstbeteiligungValues[] => {
  return state.transientState.exetremeWetterschutzSelbsbeteiligungValuesList;
};

export const selectExtremwetterschutzActiveValue = (
  state: IAppState,
): ExtremwetterschutzSelbstbeteiligung => {
  return selectSelectedProduktlinie(state).zusatzoptionen.find(
    zusatzoption => zusatzoption.name === ZusatzoptionenNameVWGEnum.ELEMENTAR,
  )?.isSelected
    ? selectExetremWetterschutzSelbstbeteiligungChosenValue(state)
    : undefined;
};
